import { Injectable } from '@angular/core';
import
{
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environment/environment';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor
{
  constructor() { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>>
  {
    if (request.url.indexOf('/api/') !== -1)
    {
      const newUrl =
        request.url[0] === '/'
          ? environment.API_BASE_URL + request.url
          : request.url;

      var lang = localStorage.getItem('lang');

      if (lang)
      {
        lang = <string>lang;
      } else
      {
        lang = environment.defaultLang;
      }

      switch (lang)
      {
        case 'ru':
          lang = 'ru-Ru';
          break;
        case 'en':
          lang = 'en-US';
          break;
        case 'uz':
          lang = 'uz-Latn-UZ';
          break;
        case 'kr':
          lang = 'kk-KZ';
      }

      request = request.clone({
        url: newUrl,
        setHeaders: { 'Accept-Language': lang },
        withCredentials: false,
      });
    }

    return next.handle(request);
  }
}
